export const FILTER_OPERATORS = {
  dateTime: ['is', 'not', 'after', 'before', 'onOrAfter', 'onOrBefore', 'isEmpty', 'isNotEmpty'],
  string: ['contains', 'equals', 'is', 'isEmpty', 'isNotEmpty'],
  singleSelect: ['is', 'not', 'isAnyOf', 'isEmpty', 'isNotEmpty'],
  number: ['=', '!=', '>', '>=', '<', '<=', 'isEmpty', 'isNotEmpty'],
} as const;

export const AUTO_ANOMALIES_REQUIRED_QUERY_FIELDS = ['wellId'] as const;

export const AUTO_ANOMALIES_DEFAULT_SORT = [{ field: 'createdAt', sort: 'desc' }] as const;

export type TAutoAnomaliesFilterKeys = keyof typeof AUTO_ANOMALIES_FIELD_CONFIG;

export type TAutoAnomaliesFieldConfig = (typeof AUTO_ANOMALIES_FIELD_CONFIG)[TAutoAnomaliesFilterKeys];

export const AUTO_ANOMALIES_FIELD_CONFIG = {
  wellId: {
    apiField: 'wellId',
    filterOperators: [],
    filterable: false,
    sortable: false,
  },
  createdAt: {
    apiField: 'createdAt',
    filterOperators: FILTER_OPERATORS.dateTime,
    filterable: true,
    sortable: true,
  },
  anomalyAt: {
    apiField: 'anomalyAt',
    filterOperators: FILTER_OPERATORS.dateTime,
    filterable: true,
    sortable: true,
  },
  updatedBy: {
    apiField: 'updatedBy.displayName',
    filterOperators: FILTER_OPERATORS.string,
    filterable: true,
    sortable: true,
  },
  anomalyTypeId: {
    apiField: 'anomalyType.typeId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  anomalySubtypeId: {
    apiField: 'anomalyType.subtypeId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  indexType: {
    apiField: 'indexType',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  sourceType: {
    apiField: 'sourceData',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  sourceOption: {
    apiField: 'curve.mnemonic',
    filterOperators: FILTER_OPERATORS.string,
    filterable: true,
    sortable: true,
  },
  limitType: {
    apiField: 'limitType',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  unitId: {
    apiField: 'unitId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  valueFact: {
    apiField: 'values.fact',
    filterOperators: FILTER_OPERATORS.number,
    filterable: true,
    sortable: true,
  },
  valueLimit: {
    apiField: 'values.limit',
    filterOperators: FILTER_OPERATORS.number,
    filterable: true,
    sortable: true,
  },
  valueAbsoluteDiff: {
    apiField: 'values.absoluteDiff',
    filterOperators: FILTER_OPERATORS.number,
    filterable: true,
    sortable: true,
  },
  valueRelativeDiff: {
    apiField: 'values.relativeDiff',
    filterOperators: FILTER_OPERATORS.number,
    filterable: true,
    sortable: true,
  },
  referenceParameterName: {
    apiField: 'referenceParameterName',
    filterOperators: FILTER_OPERATORS.string,
    filterable: true,
    sortable: true,
  },
  notification: {
    apiField: 'notification',
    filterOperators: FILTER_OPERATORS.string,
    filterable: true,
    sortable: true,
  },
  riskLevel: {
    apiField: 'riskLevel',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  bitDepth: {
    apiField: 'bitDepth',
    filterOperators: FILTER_OPERATORS.number,
    filterable: true,
    sortable: true,
  },
  holeDepth: {
    apiField: 'holeDepth',
    filterOperators: FILTER_OPERATORS.number,
    filterable: true,
    sortable: true,
  },
  wellboreId: {
    apiField: 'wellboreId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  stageTypeId: {
    apiField: 'stageTypeId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  wellboreTypeId: {
    apiField: 'wellboreTypeId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  trajectoryTypeId: {
    apiField: 'trajectoryTypeId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  sectionTypeId: {
    apiField: 'sectionTypeId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  holeType: {
    apiField: 'holeType',
    filterOperators: FILTER_OPERATORS.string,
    filterable: true,
    sortable: true,
  },
  stratUnitTypeId: {
    apiField: 'stratUnitTypeId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  reservoirId: {
    apiField: 'reservoirId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  runTypeId: {
    apiField: 'runTypeId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
  operationTypeId: {
    apiField: 'operationTypeId',
    filterOperators: FILTER_OPERATORS.singleSelect,
    filterable: true,
    sortable: true,
  },
} as const;
